import { render, staticRenderFns } from "./staffLogin.vue?vue&type=template&id=6875ef7a&scoped=true"
import script from "./staffLogin.vue?vue&type=script&lang=js"
export * from "./staffLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6875ef7a",
  null
  
)

export default component.exports